var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { PacemEventTarget, Utils, Watch, PropertyConverters, PCSS } from '@pacem/pacem-core';
import { Imaging } from '@pacem/pacem-foundation';
import { StalePropertyFlag } from '../types';
//namespace Pacem.Drawing3D {
export var KnownShader;
(function (KnownShader) {
    KnownShader["Basic"] = "basic";
    KnownShader["Lambert"] = "lambert";
    KnownShader["Phong"] = "phong";
    KnownShader["Standard"] = "standard";
    KnownShader["Line"] = "line";
    KnownShader["Custom"] = "custom";
})(KnownShader || (KnownShader = {}));
export function isMaterial(obj) {
    return /*'color' in obj &&*/ 'shader' in obj;
}
export function isBasicMaterial(obj) {
    return isMaterial(obj) && obj.shader === KnownShader.Basic;
}
export function isLineMaterial(obj) {
    return isMaterial(obj) && obj.shader === KnownShader.Line;
}
export function isLambertMaterial(obj) {
    return isMaterial(obj) && obj.shader === KnownShader.Lambert;
}
export function isPhongMaterial(obj) {
    return isMaterial(obj) && obj.shader === KnownShader.Phong;
}
export function isStandardMaterial(obj) {
    return isMaterial(obj) && obj.shader === KnownShader.Standard;
}
export function isShaderMaterial(obj) {
    return isMaterial(obj) && obj.shader === KnownShader.Custom;
}
//namespace Pacem.Components.Drawing3D {
export class MaterialElement extends PacemEventTarget {
    constructor(shader) {
        super();
        this.#shader = shader;
    }
    #shader;
    get shader() {
        return this.#shader;
    }
    async _loadMap(url, old = this.material?.texture) {
        if (!Utils.isNull(old)) {
            old.close();
        }
        if (Utils.isNullOrEmpty(url)) {
            return null;
        }
        const blob = await Imaging.loadImage(url);
        if (Utils.isNull(blob)) {
            return null;
        }
        return await createImageBitmap(blob);
    }
    propertyChangedCallback(name, old, val, first) {
        super.propertyChangedCallback(name, old, val, first);
        if (!first) {
            switch (name) {
                case 'map':
                case 'opacity':
                case 'wireframe':
                case 'color':
                case 'hide':
                    this.updateMaterial();
                    break;
            }
        }
    }
    viewActivatedCallback() {
        super.viewActivatedCallback();
        this.updateMaterial();
    }
    updateMaterial() {
        this.createMaterial().then(m => {
            this.material = Utils.extend(m, { flags: [StalePropertyFlag.Material] });
        });
    }
    async createMaterial() {
        return {
            opacity: this.opacity ?? 1.0,
            wireframe: this.wireframe ?? false,
            color: this.color || Utils.Css.getVariableValue(`--${PCSS}-color-primary`),
            visible: !(this.hide ?? false),
            map: this.map,
            texture: await this._loadMap(this.map),
            shader: this.shader,
            flags: [],
        };
    }
}
__decorate([
    Watch()
], MaterialElement.prototype, "material", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Number })
], MaterialElement.prototype, "opacity", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], MaterialElement.prototype, "wireframe", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], MaterialElement.prototype, "color", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.Boolean })
], MaterialElement.prototype, "hide", void 0);
__decorate([
    Watch({ emit: false, converter: PropertyConverters.String })
], MaterialElement.prototype, "map", void 0);
